__turbopack_context__.v({
  "change_station_dialog": "MbtwAW_change_station_dialog",
  "change_station_dialog__button": "MbtwAW_change_station_dialog__button",
  "change_station_dialog__close": "MbtwAW_change_station_dialog__close",
  "change_station_dialog__form": "MbtwAW_change_station_dialog__form",
  "change_station_dialog__header": "MbtwAW_change_station_dialog__header",
  "change_station_dialog__inner": "MbtwAW_change_station_dialog__inner",
  "change_station_dialog__input": "MbtwAW_change_station_dialog__input",
  "change_station_dialog__select": "MbtwAW_change_station_dialog__select",
  "change_station_dialog__text": "MbtwAW_change_station_dialog__text",
  "close_icon": "MbtwAW_close_icon",
  "station_option": "MbtwAW_station_option",
  "stations_list": "MbtwAW_stations_list",
  "stations_list_item": "MbtwAW_stations_list_item",
});
